// ---------------------------
// Data models & repository

export function uuid() { return Math.random().toString(36).slice(2) + Date.now().toString(36); }

// ---------------------------
export interface IUser {
  id: string;
  userName: string;
  wins?: number; // calculated on-the-fly via calculateWinLoss()
  losses?: number; // calculated on-the-fly via calculateWinLoss()
  numOfSkeeches: number;
  pointsTotal: number;
  rollsTotal: number;
  roundsTotal: number;
  gamesPlayed?: number; // calculated on-the-fly via calculateWinLoss()
  avgPPR: number; // derived from game roll histories (actual roll values, not point totals)
  createdAt: number;
  updatedAt: number;
  profile_image_url?: string;
  current_game_rolls?: number[]; // Temporary: rolls in active game (will be saved to game table, not user)
}
export interface IGame {
  id: string;
  isSoloGame: boolean;
  p1UserId: string;
  p2UserId: string | null; // only for future multiplayer; null in solo
  p1Score: number;
  p2Score: number | null;
  rounds: number; // number of rounds when finished
  rolls: number; // total balls rolled in this game
  points: number; // points by p1 in solo
  skeeches: number; // any SKEECH occurred
  timeStamp: number;
  status?: 'active' | 'completed' | 'forfeited';
  winnerId?: string; // User ID of winner (set for all completed/forfeited games)
  game_state_json?: any;
  p1_roll_history?: number[]; // Player 1's individual roll values [1, 3, 5, 0, ...]
  p2_roll_history?: number[]; // Player 2's individual roll values
  tournament_id?: string; // Tournament ID if this is a tournament game (null for regular games)
}
export function newUser(userName: string): IUser {
  const now = Date.now();
  return {
    id: uuid(), userName,
    // wins, losses, gamesPlayed are now calculated on-the-fly, not stored
    numOfSkeeches: 0,
    pointsTotal: 0, rollsTotal: 0, roundsTotal: 0,
    avgPPR: 0,
    createdAt: now, updatedAt: now,
    current_game_rolls: []
  };
}
